// extracted by css-extract-rspack-plugin
export default {"TablesDivider":"QuestionDataSource-module__TablesDivider___D5Z8Z","IconWrapper":"QuestionDataSource-module__IconWrapper___v8dse"};